import { Badge, Modal, Tabs, Tag, theme } from "antd";
import React, { useEffect, useState } from "react";
import { IBusinessFull } from "../../../../interfaces/businessFull.interface";
import { FileOutlined, DownloadOutlined } from "@ant-design/icons";
import Loader from "../../../common/loader/Loader";
import {
  selectCurrentBusiness,
  selectCurrentBusinessFiles,
} from "../../businessesSlice";
import { useAppSelector } from "../../../../app/hooks";
import BusinessUsers from "./components/BusinessUsers";
import BusinessGeneral from "./components/BusinessGeneral";
import BusinessTransactionsInfo from "./components/BusinessTransactionsInfo";
import BusinessServiceFees from "./components/BusinessServiceFees";
import BusinessPartnerInfo from "./components/BusinessPartnerInfo";
import BusinessPersons from "./components/BusinessPersons";
import BusinessPayoutDetails from "./components/BusinessPayoutInfo";
import BusinessOnboarding from "./components/BusinessOnboarding";
import BusinessFiles from "./components/BusinessFiles";
import BusinessRapydEwallets from "./components/BusinessRapydEwallets";
import type { TabsProps } from "antd";

interface IPropsBusinessModel {
  visible: boolean;
  setVisible: any;
}

export const MissingTag = <Badge count={"Missing"} />;

const BusinessDetailsModal: React.FC<IPropsBusinessModel> = ({
  visible,
  setVisible,
}) => {
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const business = useAppSelector(selectCurrentBusiness);
  const [currentBusiness, setCurrentBusiness] = useState<IBusinessFull>();

  useEffect(() => {
    if (business) {
      setCurrentBusiness(business);
    }
  }, [business]);

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setVisible(false);
    }, 3000);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "General",
      children: <BusinessGeneral />,
    },
    {
      key: "2",
      label: (
        // <Badge count={business?.onboardingFlags?.length || 0}>
        <span>Onboarding</span>
        // </Badge>
      ),
      children: <BusinessOnboarding />,
    },
    {
      key: "3",
      label: (
        // <Badge count={business?.files?.length || 0}>
        <span>Files</span>
        // </Badge>
      ),
      children: <BusinessFiles active={visible && activeTab === "3"} />,
    },
    {
      key: "transactionsInfo",
      label: "Transactions Info",
      children: <BusinessTransactionsInfo />,
    },
    {
      key: "fees",
      label: "Merchant Service Fees",
      children: <BusinessServiceFees />,
    },
    {
      key: "payoutDetails",
      label: "Payout Details",
      children: <BusinessPayoutDetails />,
    },
    {
      key: "partnerDetails",
      label: "Partner Details",
      children: <BusinessPartnerInfo />,
    },
    {
      key: "rapydWallets",
      label: "Rapyd Wallets",
      children: <BusinessRapydEwallets />,
    },
    {
      key: "persons",
      label: "Persons",
      children: <BusinessPersons />,
    },
    {
      key: "users",
      label: "Users",
      children: <BusinessUsers />,
    },
  ];

  return (
    <Modal
      title={`Business Details - ${business?.businessName || ""}`}
      open={visible}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      {currentBusiness?._id && currentBusiness.rootUser?._id && !loading && (
        <div>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={items}
            type="card"
            style={{ marginTop: token.marginMD }}
          />
        </div>
      )}

      {loading && <Loader text="Fetching Business Details" />}
    </Modal>
  );
};

export default BusinessDetailsModal;
